import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Chip from "@material-ui/core/Chip";
import dayjs from "dayjs";

const useStyles = makeStyles({
  card: {
    marginBottom: 12,
  },
  cardContent: {
    paddingBottom: 8,
  },
  header: {
    marginBottom: 12,
  },
  groupName: {
    fontWeight: 600,
    fontSize: 16,
    color: "#006EB3",
  },
  infoGrid: {
    marginTop: 8,
  },
  label: {
    fontSize: 12,
    color: "#666",
    marginBottom: 4,
  },
  value: {
    fontWeight: 500,
    fontSize: 14,
  },
  cardActions: {
    padding: "8px 16px",
    paddingTop: 0,
  },
});

export default function UserGroupCard({ group, onView }) {
  const classes = useStyles();

  return (
    <Card className={classes.card} variant="outlined">
      <CardContent className={classes.cardContent}>
        <div className={classes.header}>
          <Typography className={classes.groupName}>{group.name}</Typography>
        </div>

        <Grid container spacing={2} className={classes.infoGrid}>
          <Grid item xs={12}>
            <Typography className={classes.label}>Description</Typography>
            <Typography className={classes.value}>
              {group.description?.length
                ? group.description
                : "Not Specified"}
            </Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography className={classes.label}>Members</Typography>
            <Chip
              label={group.members.length}
              size="small"
              color="primary"
              style={{ fontWeight: 600 }}
            />
          </Grid>

          <Grid item xs={6}>
            <Typography className={classes.label}>Created</Typography>
            <Typography className={classes.value}>
              {dayjs(group.start_date).format("DD/MM/YYYY")}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>

      <CardActions className={classes.cardActions}>
        <Button
          variant="outlined"
          color="primary"
          fullWidth
          disabled={!group.members.length}
          onClick={onView}
        >
          View Members
        </Button>
      </CardActions>
    </Card>
  );
}
